import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const options = [
  '농협은행',
  '국민은행',
  '신한은행',
  '제주은행',
  '기업은행',
  '우리은행',
  '우체국은행',
  '광주은행',
  '전북은행',
  'SC제일은행',
  '케이뱅크',
  '대구은행',
  'KEB하나은행',
  '카카오뱅크',
  '경남은행',
  '부산은행',
  '한국시티은행',
  '수협',
  'HSBC',
  'KDB산업은행',
  '저축은행',
  '새마을금고',
].map((val) => ({ value: val, label: val }));

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: 58,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition };
  },
};

class Index extends PureComponent {
  render() {
    const { value, onChange } = this.props;
    return (
      <Select
        options={options}
        styles={customStyles}
        placeholder={'은행명 선택'}
        onChange={(val) => onChange(val.value)}
        value={value ? { value, label: value } : null}
      />
    );
  }
}

Index.propTypes = {};

export default Index;
